// extracted by mini-css-extract-plugin
export default {"CandidateShareResultPage":"zKrHF","CandidateShareResultPage__content":"OvP5y","CandidateShareResultPage__loading":"u4Qut"};